/* Stylesheets */
import "./scss/vendors/bootstrap.scss"; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
// import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
// import './scss/vendors/hamburgers.scss'; // ref: https://jonsuh.com/hamburgers/#sass
import './scss/fonts.scss';
import './scss/vendors/energy-saver.scss';
import "./scss/main.scss";

/* Scripts */
// import { } from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.
import { Modal, Tooltip } from 'bootstrap';
window.Modal = Modal; // Espone Modal globalmente

// import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
// import { } from 'swiper/modules';
// const swiperTranslations = {
//     firstSlideMessage: `Questa è la prima slide`,
//     lastSlideMessage: `Questa è l'ultima slide`,
//     nextSlideMessage: `Vai alla prossima slide`,
//     paginationBulletMessage: `Vai alla slide {{index}}`,
//     prevSlideMessage: `Vai alla slide precedente`,
//     slideLabelMessage: `{{index}} di {{slidesLength}}`
// } // Oggetto da passare alla proprietà a11y: { ...options, ...swiperTranslations } dell'istanza Swiper - ref: https://docs.google.com/presentation/d/1dhMLaonvwWgX0t-fAxPU4PubI_u6QTrl10IfM6Badng/edit?slide=id.g3a1f0c75b34_0_0#slide=id.g3a1f0c75b34_0_0

import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { faFreeB } from '@fortawesome/free-brands-svg-icons';
// import { faFreeS } from '@fortawesome/free-solid-svg-icons';
// import {  } from '@fortawesome/free-regular-svg-icons';
import { faCircleInfo as faCircleInfoSolid } from '@fortawesome/pro-solid-svg-icons';
import { faCircleUser, faCircleInfo, faEye, faEyeSlash, faUpFromBracket, faFaceFrown, faPaperPlaneTop } from '@fortawesome/pro-regular-svg-icons';
// import { faProL } from '@fortawesome/pro-light-svg-icons';
// import { faProT } from '@fortawesome/pro-thin-svg-icons';
// import { faProD } from '@fortawesome/pro-duotone-svg-icons';
// import { faDuotoneR } from '@fortawesome/duotone-regular-svg-icons';
// import { faDuotoneL } from '@fortawesome/duotone-light-svg-icons';
// import { faDuotoneT } from '@fortawesome/duotone-thin-svg-icons';
// import { faSharpS } from '@fortawesome/sharp-solid-svg-icons';
// import { faSharpR } from '@fortawesome/sharp-regular-svg-icons';
// import { faSharpL } from '@fortawesome/sharp-light-svg-icons';
// import { faSharpT } from '@fortawesome/sharp-thin-svg-icons';
// import { faSharpD } from '@fortawesome/sharp-duotone-solid-svg-icons';
// import { faSharpDR } from '@fortawesome/sharp-duotone-regular-svg-icons';
// import { faSharpDL } from '@fortawesome/sharp-duotone-light-svg-icons';
// import { faSharpDT } from '@fortawesome/sharp-duotone-thin-svg-icons';
// import { faFree } from '@fortawesome/fontawesome-free';
// import { faPro } from '@fortawesome/fontawesome-pro';
library.add(faCircleUser, faCircleInfo, faCircleInfoSolid, faEye, faEyeSlash, faUpFromBracket, faFaceFrown, faPaperPlaneTop);
// library.add(faDuotoneR, faDuotoneL, faDuotoneT);
// library.add(faSharpS, faSharpR, faSharpL, faSharpT, faSharpD, faSharpDR, faSharpDL, faSharpDT);
// library.add(faFree, faPro);
dom.i2svg();

import EnergySaver from './js/vendors/energy-saver';

const energyS = new EnergySaver({
    enableZeroImpact: false
    // enableZeroImpactTarget: "#zeroimpact"
});

import Cleave from "cleave.js";
require("cleave.js/dist/addons/cleave-phone.it");

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

const isDebug = process.env.NODE_ENV !== "production";

/* Variables and functions */
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

const goToAnchor = (el, offset = 0, behavior = "smooth") => {
    if (typeof el === "string") {
        el = document.querySelector(el);
    }

    if (el) {
        // calc header height
        const header = document.querySelector("header");
        const headerHeight = header ? header.offsetHeight : 0;
        const y = el.getBoundingClientRect().top + window.scrollY - offset - headerHeight;
        window.scrollTo({
            top: y,
            behavior: behavior,
        });
    }
};

const getHashTarget = () => {
    if (!window.location.hash) return null;
    try {
        return document.querySelector(window.location.hash);
    } catch (e) {
        return null;
    }
};

const initAnchorScroll = () => {
    // Arrivo in pagina con un #hash (es. da Registrati -> menu "Premi"):
    // il salto all'ancora lo fa il browser nativamente, senza compensare l'header fisso.
    // Correggiamo subito dopo il posizionamento nativo e di nuovo a load completato
    // (il caricamento delle immagini sposta le sezioni).
    const correct = (behavior) => {
        const target = getHashTarget();
        if (target) goToAnchor(target, 0, behavior);
    };

    if (window.location.hash) {
        setTimeout(() => correct("instant"), 0);
        window.addEventListener("load", () => correct("instant"), { once: true });
    }

    // Navigazione ad ancore nella stessa pagina
    window.addEventListener("hashchange", () => correct("smooth"));
};

const showLoading = (el) => {
    el?.classList.add("disabled");

    const loadingLayer = document.querySelector(".loading-layer");
    if (loadingLayer) {
        loadingLayer.style.display = "block";
    }
};

const hideLoading = () => {
    const loadingButtons = [...document.querySelectorAll(".btn-loading")];
    loadingButtons.forEach((button) => {
        button.classList.remove("disabled");
    });

    const loadingLayer = document.querySelector(".loading-layer");
    if (loadingLayer) {
        loadingLayer.style.display = "none";
    }
};

const initCleave = () => {
    const Cap = document.getElementById("Input_Cap");
    if (Cap) {
        new Cleave(Cap, {
            blocks: [5],
            numericOnly: true,
        });
    }

    const TelefonoRaw = document.getElementById("Input_Telefono");
    if (TelefonoRaw) {
        new Cleave(TelefonoRaw, {
            phone: true,
            phoneRegionCode: "IT",
        });
    }

    const DataDiNascita = document.getElementById("Input_DataNascita");
    if (DataDiNascita) {
        new Cleave(DataDiNascita, {
            date: true,
            delimiter: "/",
            datePattern: ["d", "m", "Y"],
        });
    }

    const Input1_Data = document.getElementById("Input1_Data");
    if (Input1_Data) {
        new Cleave(Input1_Data, {
            date: true,
            delimiter: "/",
            datePattern: ["d", "m", "Y"],
        });
    }

    const Input2_Data = document.getElementById("Input2_Data");
    if (Input2_Data) {
        new Cleave(Input2_Data, {
            date: true,
            delimiter: "/",
            datePattern: ["d", "m", "Y"],
        });
    }

    const Input1_Ora = document.getElementById('Input1_Ora');
    if (Input1_Ora) {
        new Cleave(Input1_Ora, {
            time: true,
            timePattern: ['h', 'm']
        });
    }

    const Input2_Numero = document.getElementById('Input2_Numero');
    if (Input2_Numero) {
        new Cleave(Input2_Numero, {
            blocks: [15],
            numericOnly: false
        });
    }

    const Input1_Importo = document.getElementById('Input1_Importo');
    if (Input1_Importo) {
        new Cleave(Input1_Importo, {
            numeralDecimalMark: ',',
            numeralDecimalScale: 2,
            numeralThousandsGroupStyle: 'none',
            numeral: true
        });
    }

    const Input2_Importo1prod = document.getElementById('Input2_Importo1prod');
    if (Input2_Importo1prod) {
        new Cleave(Input2_Importo1prod, {
            numeralDecimalMark: '',
            numeralThousandsGroupStyle: 'none',
            numeral: true
        });
    }

    const Input2_Importo = document.getElementById('Input2_Importo');
    if (Input2_Importo) {
        new Cleave(Input2_Importo, {
            numeral: true,
            numeralDecimalMark: ',',
            numeralDecimalScale: 2,
            numeralThousandsGroupStyle: 'none'
        });
    }
};

const initShowPassword = () => {
    [...document.querySelectorAll(".show-pwd")].forEach((eye) => {
        // Imposta gli attributi iniziali di accessibilità
        eye.setAttribute("type", "button");
        eye.setAttribute("aria-label", "Mostra password");
        eye.setAttribute("aria-pressed", "false");

        eye.addEventListener("click", (e) => {
            e.preventDefault();

            const iconPasswordContainer = eye.closest(".input-group");
            const passwordInput = iconPasswordContainer?.parentNode.querySelector("input");
            if (!passwordInput) return;

            const isPassword = passwordInput.getAttribute("type") === "password";
            passwordInput.setAttribute("type", isPassword ? "text" : "password");

            // Aggiorna gli attributi di accessibilità
            eye.setAttribute("aria-label", isPassword ? "Clicca qui per nascondere la password" : "Clicca qui per mostrare la password");
            eye.setAttribute("aria-pressed", isPassword ? "true" : "false");

            // Rimuovi l'SVG esistente
            const oldSvg = eye.querySelector("svg");
            if (oldSvg) {
                oldSvg.remove();
            }

            // Crea un nuovo elemento <i> con la classe corretta
            const newIcon = document.createElement("i");
            newIcon.className = isPassword ? "fa-regular fa-eye-slash fa-fw" : "fa-regular fa-eye fa-fw";
            newIcon.setAttribute("aria-hidden", "true");
            eye.appendChild(newIcon);

            // Converti il nuovo <i> in SVG
            dom.i2svg({ node: eye });
        });
    });
};

const initFormValidation = () => {
    const forms = document.querySelectorAll(".needs-validation");
    if (forms) {
        Array.from(forms).forEach((form) => {

            // Gestione radio button: raggruppa per name
            const handleRadioGroupValidation = () => {
                const radioGroups = {};
                form.querySelectorAll('input[type="radio"]').forEach(radio => {
                    const name = radio.name;
                    if (!radioGroups[name]) radioGroups[name] = [];
                    radioGroups[name].push(radio);
                });

                Object.values(radioGroups).forEach(radios => {
                    const isValid = radios.some(r => r.checked);

                    radios.forEach(r => {
                        if (isValid) {
                            r.removeAttribute("aria-invalid");
                        } else {
                            r.setAttribute("aria-invalid", "true");
                        }
                    });

                    // Cerca lo span errore come sibling successivo del div.d-flex
                    // che contiene i radio button
                    const container = radios[0].closest(".radio-container");
                    if (container) {
                        const errorSpan = container.querySelector(".invalid-feedback");
                        if (errorSpan) {
                            errorSpan.style.display = isValid ? "none" : "block";
                        }
                    }
                });
            };

            let allInputs = form.querySelectorAll("input, select, textarea");
            allInputs.forEach(function (el) {
                el.addEventListener("change", function () {
                    if (el.type === "radio") {
                        handleRadioGroupValidation();
                    } else {
                        if (el.checkValidity()) {
                            el.removeAttribute("aria-invalid");
                        } else {
                            el.setAttribute("aria-invalid", "true");
                        }
                    }
                });
            });

            form.addEventListener("submit", (e) => {
                form.classList.add("was-validated");

                let validFields = form.querySelectorAll("*:valid");
                let invalidFields = form.querySelectorAll("*:invalid");

                validFields.forEach(f => f.removeAttribute("aria-invalid"));
                invalidFields.forEach(f => f.setAttribute("aria-invalid", "true"));

                // Gestisci sempre i radio al submit
                handleRadioGroupValidation();

                if (!form.checkValidity()) {
                    e.preventDefault();
                    e.stopPropagation();
                    invalidFields[0].focus();
                } else {
                    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
                    showLoading(submitButton);
                }
            }, false);
        });
    }
};

const closeMenuByNav = () => {
    Array.from(document.querySelectorAll('.nav-link'))
        .forEach((el) => el.addEventListener('click', (evt) => {
            let navbar = document.getElementById('navbarNav');
            navbar.classList.remove('show');

            document.querySelector('button.navbar-toggler').classList.add('collapsed'); 
        }));
}

const initReceiptUpload = () => {
    // (accessibilità) focus sugli input file, per attivare il focus sul contenitore padre
    ["Input1_FileFronte", "Input1_FileRetro", "Input1_Prodotti_file", "Input2_FileFronte", "Input2_FileRetro", "Input2_Prodotti_file"].forEach(id => {
        const input = document.getElementById(id);
        const uploadCopy = input?.closest(".wrap-upload")?.querySelector(".upload-copy");
        if (input && uploadCopy) {
            input.addEventListener("focus", () => uploadCopy.classList.add("focused"));
            input.addEventListener("blur", () => uploadCopy.classList.remove("focused"));
        }
    });

    // === TROVO I PARAMETRI DEL FORM ===
    const form = document.querySelector("form[data-prefix]");
    if (!form) return;
    const prefix = form.dataset.prefix;
    const userId = window.userID; // ATTENZIONE agli apici!
    const jsonDataEl = document.getElementById(`${prefix}_JsonData`);

    // === INPUT FILE E DIV ERROR ===
    const btnFronte = document.getElementById(`${prefix}_FileFronte`);
    const btnRetro = document.getElementById(`${prefix}_FileRetro`);
    const btnProdotti = document.getElementById(`${prefix}_Prodotti_file`);
    const errFronte = "uploadErrorFronte";
    const errRetro = "uploadErrorRetro";
    const errProdotti = "uploadErrorProdotti";

    // === helper: soddisfa/riattiva il required del file in base alla presenza dell'immagine ===
    function satisfyFileRequirement(prefix, tipo, satisfied) {
        const idMap = {
            fronte: `${prefix}_FileFronte`,
            retro: `${prefix}_FileRetro`,
            prodotti: `${prefix}_Prodotti_file`
        };
        const input = document.getElementById(idMap[tipo]);
        if (!input) return;

        if (satisfied) {
            input.removeAttribute("required");
            input.required = false;
            input.setCustomValidity(""); // pulisce stato invalid del browser (se c'era)
            input.classList.remove("is-invalid");
            const invalidId = input.getAttribute("aria-describedby");
            if (invalidId) {
                const inv = document.getElementById(invalidId);
                inv?.classList?.remove("d-block");
            }
        } else {
            // NB: qui applichiamo il required solo per fronte/prodotti (retro mai)
            if (tipo !== "retro") {
                input.setAttribute("required", "required");
                input.required = true;
            }
            input.setCustomValidity(""); // prevenire stati sporchi
        }
    }

    // === MOSTRA MESSAGGIO ERRORE ALL'UTENTE ===
    function showUserError(id) {
        const d = document.getElementById(id);
        if (!d) return;
        d.textContent =
            "Il file non è stato caricato correttamente. " +
            "Verifica formato e peso (max 5 MB; jpg, png, pdf) e riprova. " +
            "Se persiste, riprova più tardi.";
        d.classList.remove("d-none");
    }

    // === FETCH CON GESTIONE 400 ===
    async function fetchData(fd, tipo, errId) {
        const d = document.getElementById(errId);
        if (d) d.classList.add("d-none");
        try {
            const res = await fetch("/api/FileUpload/upload", { method: "POST", body: fd });
            if (!res.ok) {
                if (res.status === 400) showUserError(errId);
                throw new Error(`HTTP ${res.status}`);
            }
            const data = await res.json();
            jsonDataEl.value = JSON.stringify(data);
            elabResponse(data, tipo);
        } catch (err) {
            console.error("Errore durante l'upload:", err);
        } finally {
            hideLoading?.();
        }
    }

    // === PREPARA E INVIA IL FORM DATA ===
    function onUploading(file, tipo, errId) {
        if (!file || !userId) return;

        const lblId = (tipo === "prodotti") ? "lblNomeFileProdotti"
            : (tipo === "retro") ? "lblNomeFileRetro"
                : "lblNomeFileFronte";
        const lbl = document.getElementById(lblId);
        lbl?.classList.add('opacity-50');

        const loaderId = (tipo === "prodotti") ? "loaderNomeFileProdotti"
            : (tipo === "retro") ? "loaderNomeFileRetro"
                : "loaderNomeFileFronte";
        const loader = document.getElementById(loaderId);
        showLoading(loader);

        const fd = new FormData();
        fd.append("file", file);
        fd.append("front_back", tipo);
        fd.append("receipt_invoice", prefix === "Input1" ? "scontrino" : "fattura");
        fd.append("uid", userId);
        fd.append("jsondata", jsonDataEl.value || "");
        fetchData(fd, tipo, errId);
    }

    // === ATTACH EVENTI AI CAMPI FILE ===
    btnFronte?.addEventListener("change", e => {
        // se l'utente cambia immagine, torna required finché non c'è un valore valido
        satisfyFileRequirement(prefix, "fronte", false);
        onUploading(e.target.files[0], "fronte", errFronte);
    });

    btnRetro?.addEventListener("change", e => {
        // RETRO OPZIONALE: non impostiamo mai required sul retro
        onUploading(e.target.files[0], "retro", errRetro);
    });

    btnProdotti?.addEventListener("change", e => {
        satisfyFileRequirement(prefix, "prodotti", false);
        onUploading(e.target.files[0], "prodotti", errProdotti);
    });

    // === RICARICO LE PREVIEW SE TORNO INDIETRO / POSTBACK CON ERRORI ===
    loadImageOnPostback();

    // === PRIMA DI INVIARE IL FORM: il required deve riflettere i campi hidden ===
    form.addEventListener("submit", () => {
        // imponi required SOLO a fronte e prodotti
        ["fronte", "prodotti"].forEach(tipo => {
            const hid = (tipo === "prodotti")
                ? `${prefix}_Prodotti_hidden`
                : `${prefix}_${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
            const hasValue = !!document.getElementById(hid)?.value;
            satisfyFileRequirement(prefix, tipo, hasValue);
        });
        // per il retro, non facciamo nulla: resta opzionale
    });

    // ===============================
    // === FUNZIONI DI SUPPORTO ====
    // ===============================
    function elabResponse(res, tipo) {
        chooseImage(res.immagini, tipo);
        // Se vuoi auto-precompilare dal tuo OCR:
        // if (tipo !== "prodotti" && res.datiOCR) prefillOcrData(res.datiOCR);
    }

    function chooseImage(arr, tipo) {
        const map = { fronte: 1, retro: 2, prodotti: 3 };
        const imgObj = arr?.find(i => i.tipo === map[tipo])?.immagine;
        if (!imgObj) {
            console.warn(`Immagine tipo ${tipo} non trovata`);
            return;
        }
        // aggiorno il campo hidden
        const hid = (tipo === "prodotti")
            ? `${prefix}_Prodotti_hidden`
            : `${prefix}_${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
        const hidEl = document.getElementById(hid);
        if (hidEl) hidEl.value = JSON.stringify(imgObj);

        writeImage(imgObj, tipo);
    }

    function writeImage(img, tipo) {
        const s3 = img.s3link;
        const isPdf = /\.pdf$/i.test(s3);
        const lblId = (tipo === "prodotti") ? "lblNomeFileProdotti"
            : (tipo === "retro") ? "lblNomeFileRetro"
                : "lblNomeFileFronte";
        const btnId = (tipo === "prodotti") ? `${prefix}_Prodotti_file`
            : (tipo === "retro") ? `${prefix}_FileRetro`
                : `${prefix}_FileFronte`;

        const uplWp = (tipo === "prodotti") ? `.wrap-upload_Prodotti_file`
            : (tipo === "retro") ? `.wrap-upload_FileRetro`
                : `.wrap-upload_FileFronte`;

        const lbl = document.getElementById(lblId);
        const btn = document.getElementById(btnId);
        const wrapUpload = document.querySelector(uplWp);

        //console.log(uplWp)
        lbl?.classList.remove('opacity-50');

        if (!lbl || !btn) return;

        lbl.innerHTML = "";
        //btn.classList.add("d-none");
        lbl.classList.remove("d-none");

        if (wrapUpload) wrapUpload.classList.add("opacity-25");

        const a = document.createElement("a");
        a.href = s3;
        a.target = "_blank";
        a.classList.add("preview", "me-3");
        a.setAttribute("aria-label", "Anteprima");

        const label = document.createElement("p");
        label.classList.add('fw-bold', 'text-uppercase', 'mb-1');
        label.innerHTML = tipo;

        if (isPdf) {
            //a.textContent = typeof svgIcoPDF !== "undefined" ? svgIcoPDF : "PDF";
            const icon = document.createElement('i');
            icon.classList.add('fa-light', 'fa-file-pdf', 'fa-3x');
            a.appendChild(icon);
        } else {
            const im = document.createElement("img");
            im.src = s3;
            im.alt = "";
            //im.classList.add("object-fit-cover");
            //im.style.maxWidth = "250px";
            //im.style.maxHeight = "250px";
            a.appendChild(im);
        }

        const nome = document.createElement('div');
        nome.classList.add('form-text', 'mt-2');
        nome.innerHTML = img?.nomeOriginale ?? '';


        console.log({ img });

        //const br = document.createElement("br");
        //const chg = document.createElement("a");
        //chg.href = "javascript:;";
        //chg.textContent = `Cambia immagine ${tipo}`;
        //chg.classList.add("btn", "btn-cambia-upload", "btn-blue", "btn-sm", "fs-x-small", "d-inline-block");
        //chg.onclick = () => {
        //    // riattivo il required SOLO per i campi che lo prevedono
        //    if (tipo !== "retro") satisfyFileRequirement(prefix, tipo, false);
        //    document.getElementById(btnId).click();
        //};

        lbl.append(label, a, nome);

        // immagine presente: rimuovi eventuale required/invalid
        satisfyFileRequirement(prefix, tipo, true);
    }

    function loadImageOnPostback() {
        ["fronte", "retro", "prodotti"].forEach(tipo => {
            const hid = (tipo === "prodotti")
                ? `${prefix}_Prodotti_hidden`
                : `${prefix}_${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
            const v = document.getElementById(hid)?.value;
            if (v) {
                // ridisegno la preview e soddisfo i required relativi
                writeImage(JSON.parse(v), tipo);
                satisfyFileRequirement(prefix, tipo, true);
            }
        });
    }

    function fmtDate(i) {
        const d = new Date(i); if (isNaN(d)) return "";
        return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
    }
    function fmtTime(i) {
        const d = new Date(i); if (isNaN(d)) return "";
        return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    }
    function fmtPrice(v) {
        const n = Number(v); if (isNaN(n)) return "";
        return n.toFixed(2).replace(".", ",");
    }
}

function goBack() {
    document.getElementById("inputIndietro").value = "true";
}

/* ===============================
   === AGE GATE MANAGEMENT ===
   =============================== */


/* Ready callback function */
ready(() => {
    initWebpackVersion();
    // AgeGate.init();
    initCleave();
    initShowPassword();
    initFormValidation();
    closeMenuByNav();
    initReceiptUpload();
    initAnchorScroll();
    Array.from(document.getElementsByClassName('submit')).forEach((element) => {
        element.addEventListener("click", (e) => {
            showLoading(element);
        });
    });

    // Inizializza il sistema di controllo age gate
});

window.goToAnchor = goToAnchor;
window.showLoading = showLoading;
window.hideLoading = hideLoading;
window.goBack = goBack;
// window.AgeGate = AgeGate;